import React from 'react';
import { Grid, Button } from '@mui/material';
import { Switch as EsgSwitch } from 'components';
import { fieldStyles } from '../../styles';

interface ActionButtonsProps {
    editCollector?: any;
    isNotesOnlyMode: boolean;
    isSpendBasedEstimation: boolean;
    isSubmitting?: boolean;
    isFormValid?: boolean;
    hasPermission?: boolean;
    onSpendBasedToggle: () => void;
    onCancel: () => void;
    onSave: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
    editCollector,
    isNotesOnlyMode,
    isSpendBasedEstimation,
    isSubmitting = false,
    isFormValid = true,
    hasPermission = true,
    onSpendBasedToggle,
    onCancel,
    onSave,
}) => {
    // Disable save button when submitting, form is invalid, or user lacks permission
    const isSaveDisabled = isSubmitting || (!isNotesOnlyMode && !isFormValid) || !hasPermission;

    return (
        <Grid container alignItems="center" justifyContent="flex-end" mb={2} ml={2}>
            {!isNotesOnlyMode && (
                <Grid item>
                    <EsgSwitch
                        isChecked={isSpendBasedEstimation}
                        label="Spend Based Estimation"
                        onChange={onSpendBasedToggle}
                        disabled={isSubmitting}
                    />
                </Grid>
            )}
            <Grid item sx={fieldStyles.actionButtonsContainer}>
                <Button onClick={onCancel} disabled={isSubmitting}>Cancel</Button>
                <Button
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                    disabled={isSaveDisabled}
                >
                    {isSubmitting
                        ? "Saving..."
                        : isNotesOnlyMode || editCollector
                            ? "Save"
                            : "Add"
                    }
                </Button>
            </Grid>
        </Grid>
    );
}
